// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogSubscriptionsListDatatableResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      created_at: string,
      item_id: string,
      type: string,
      user_id: string,
    })
  ),
});
